// extracted by mini-css-extract-plugin
export var connectionButton = "_af-1";
export var rightPanel = "_af-3";
export var stepDescription = "_af-2";
export var stepIcon = "_af-0";